module.exports = __webpack_public_path__ + "static/media/zm.ee80782a.svg";